import { useQuery } from '@tanstack/react-query';

import { AuthService } from './authService';
import { AuthKey } from './keys';

export function useGetSession() {
  return useQuery({
    queryKey: [AuthKey.SESSION],
    queryFn: () => AuthService.getSession().then((response) => response.data),
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    staleTime: 120000,
    retry: 2,
  });
}
